// Dated org-age gates ("orgs created on/after X get the new behavior") — the
// idiom behind LiveKit auto-enable, Enterprise gating, and the onboarding
// banners. Extracted so the comparison is spelled (and tested) exactly once.
//
// `org_created_at` arrives as "YYYY-MM-DD HH:mm:ss". The fixed-width date
// prefix string-compares against a YYYY-MM-DD cutoff without timezone-parsing
// ambiguity. Absent data returns false — each caller decides what that means
// (fail open for entitlement locks, fail closed for promotional banners).
// A full "YYYY-MM-DD HH:mm:ss" cutoff works too, exact to the second.
export const isOrgCreatedOnOrAfter = (orgCreatedAt: string | undefined, cutoff: string): boolean =>
  orgCreatedAt ? orgCreatedAt >= cutoff : false
